import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "@mui/material";
import { getLoginCookieAndSession } from "../../utils";

const Sell: React.FC = () => {
  const navigate = useNavigate();
  const profileId = getLoginCookieAndSession();

  useEffect(() => {
    if (!profileId) {
      navigate("/", { replace: true });
    }
  }, [profileId, navigate]);

  if (!profileId) return null;

  return <Container maxWidth="md" sx={{ py: 3 }} />;
};

export default Sell;
